import { render } from "./content-tabs.vue?vue&type=template&id=31b5c463&scoped=true"
import script from "./content-tabs.vue?vue&type=script&lang=js"
export * from "./content-tabs.vue?vue&type=script&lang=js"

import "./content-tabs.vue?vue&type=style&index=0&id=31b5c463&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b5c463"]])

export default __exports__